import styled from 'styled-components'
import PropTypes from 'prop-types'

const gridArea = 'coll'
const Wrap = styled.div`
  grid-area: ${gridArea};
  grid-column-start: 1;
  grid-column-end: ${({ end }) => end};
  background-color: ${({ bgColor }) => bgColor};
`
const ColumnLeft = ({ children, bgColor = 'white', end = 7, ...rest }) => {
  return (
    <Wrap bgColor={bgColor} end={end} {...rest}>
      {children}
    </Wrap>
  )
}

ColumnLeft.propTypes = {
  /** The ending column track */
  end: PropTypes.oneOf([2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
  bgColor: PropTypes.string,
  children: PropTypes.node.isRequired
}
ColumnLeft.slotName = 'PageColumnLeft'

export { ColumnLeft, gridArea }
